import { FlyoutType, openFlyout } from '@paid-ui/blocks/global-flyout';
import { EmailIcon } from '@paid-ui/icons/email';

import { NavbarIconButton } from '../navbar-button';

export const HelpCenter: React.FC = () => {
  return (
    <NavbarIconButton
      className="group flex flex-col justify-center gap-2 py-4 sm:h-16 sm:w-full"
      onClick={() =>
        openFlyout(FlyoutType.HELP_CENTER, {
          className: 'w-[752px]',
          showCloseIcon: true,
          closeOnClickOutside: true,
        })
      }
    >
      <EmailIcon className="text-white/70 group-hover:text-white group-focus:text-white sm:h-5 sm:w-5" />
      <span className="hidden flex-1 text-xs sm:inline-block">Help</span>
    </NavbarIconButton>
  );
};
